import { render, staticRenderFns } from "./engineering.vue?vue&type=template&id=1e54573e&scoped=true"
import script from "./engineering.vue?vue&type=script&lang=js"
export * from "./engineering.vue?vue&type=script&lang=js"
import style0 from "./engineering.vue?vue&type=style&index=0&id=1e54573e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e54573e",
  null
  
)

export default component.exports